import React, { useEffect, useState } from 'react';
const STORAGE_KEY = 'badminton-ready-launch-deadline';
const DAY_IN_MS = 24 * 60 * 60 * 1000;
interface TimeLeft {
  hours: number;
  minutes: number;
  seconds: number;
}
export function CountdownBar() {
  const [timeLeft, setTimeLeft] = useState<TimeLeft>({
    hours: 24,
    minutes: 0,
    seconds: 0
  });
  useEffect(() => {
    const stored = Number(window.localStorage.getItem(STORAGE_KEY));
    let deadline = Number.isFinite(stored) && stored > Date.now() ? stored : Date.now() + DAY_IN_MS;
    window.localStorage.setItem(STORAGE_KEY, String(deadline));
    const updateTimer = () => {
      const now = Date.now();
      if (deadline <= now) {
        deadline = now + DAY_IN_MS;
        window.localStorage.setItem(STORAGE_KEY, String(deadline));
      }
      const seconds = Math.max(0, Math.ceil((deadline - now) / 1000));
      setTimeLeft({
        hours: Math.floor(seconds / 3600),
        minutes: Math.floor(seconds % 3600 / 60),
        seconds: seconds % 60
      });
    };
    updateTimer();
    const interval = window.setInterval(updateTimer, 1000);
    return () => window.clearInterval(interval);
  }, []);
  return <aside className="sticky top-0 z-50 flex h-8 w-full items-center justify-center bg-brand-blue px-2 text-white shadow-sm" data-id="element-36" data-mp="18e51fr460mur">
      <div className="flex items-center gap-2 sm:gap-3" data-id="element-37" data-mp="uf5dkloh8bzn">
        <p className="whitespace-nowrap text-[9px] font-extrabold tracking-wide sm:text-[10px]" data-id="element-38" data-mp="ye5vm1z4rall">🏸 LAUNCH PRICE ENDS IN:</p>
        <div className="flex items-center gap-1 font-mono" aria-label={`${timeLeft.hours} hours, ${timeLeft.minutes} minutes, ${timeLeft.seconds} seconds remaining`} data-id="element-39" data-mp="1m5thu6lg5xhj">
          <TimerUnit value={timeLeft.hours} label="HRS" data-id="element-40" data-mp="1dcq6c3ud3upj" /><span className="text-xs font-bold" data-id="element-41" data-mp="1dby9kpp13qxo">:</span>
          <TimerUnit value={timeLeft.minutes} label="MIN" data-id="element-42" data-mp="1hd09z9uom918" /><span className="text-xs font-bold" data-id="element-43" data-mp="1hbp6lb55f3an">:</span>
          <TimerUnit value={timeLeft.seconds} label="SEC" data-id="element-44" data-mp="2534b9akedwp2" />
        </div>
      </div>
    </aside>;
}
function TimerUnit({
  value,
  label
}: {
  value: number;
  label: string;
}) {
  return <span className="whitespace-nowrap text-[11px] font-extrabold sm:text-xs" data-id="element-45" data-mp="2jpt9za6ts5ue">{String(value).padStart(2, '0')}<span className="ml-0.5 text-[8px] font-bold text-white/70" data-id="element-46" data-mp="2fnybsek6y8ku">{label}</span></span>;
}